import React from 'react';
import cx from 'classnames';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import styles from './style.module.scss';
import {FormViewEnum} from '../../../../stores/Form/Form';

type Props = {
    onViewChange: (viewType: FormViewEnum) => void;
    activeView: FormViewEnum;
    componentClasses?: string;
};

const views = {
    table: PriorityIcon.tableView,
    form: PriorityIcon.recordView
};

export const FormViewToggler = ({onViewChange, activeView, componentClasses}: Props) => {
    return (
        <div className={cx(styles.gridViewToggler, componentClasses)}>
            {Object.keys(views).map((view: string) => {
                return (
                    <div
                        key={view}
                        className={cx(styles.btn, {[styles.active]: activeView === view})}
                    >
                        <Icon
                            onClick={() => onViewChange(view as FormViewEnum)}
                            icon={views[view]}
                        />
                    </div>
                );
            })}
        </div>
    );
};
